<div class="cart">
  <ng-container>
    <div class="cart-details">
      <div id="cart-title" class="pull-left text-center">
        Meu carrinho de compras
      </div>
      <div id="cart-icon" class="pull-right text-center  hidden-md">
        <i class="fa fa-shopping-cart" aria-hidden="true"></i>
      </div>
      <div class="clearfix">&nbsp;</div>
      <div id="cart-buttons">
        <button class="btn btn-cart" *ngIf="this.pedido == null" [disabled]="carrinho?.quantidade == 0" (click)="limpar(carrinho?.carrinho_id)">
          <i class="fa fa-trash" aria-hidden="true"></i>&nbsp;
        </button>
        <a class="btn btn-cart" [routerLink]="pedido ? '/checkout/pagamento' : '/checkout/carrinho'">{{ carrinho?.quantidade }} itens &nbsp;&nbsp;
          {{ carrinho?.preco | price }}</a>
      </div>
      <i class="fa fa-caret-down" aria-hidden="true"></i>
    </div>

    <a class="btn btn-checkout center-block mb10" *ngIf="!pedido" routerLink="/checkout/carrinho" [ngClass]="{ disabled: carrinho.quantidade <= 0 }">
      <i class="fa fa-shopping-cart" aria-hidden="true"></i>&nbsp;&nbsp;&nbsp;Finalizar compra &nbsp;
      <i class="fa fa-shopping-cart" aria-hidden="true"></i>
    </a>
    <a class="btn btn-checkout  center-block mb10" *ngIf="pedido" routerLink="/checkout/pagamento">
      <i class="fa fa-shopping-cart" aria-hidden="true"></i>&nbsp;&nbsp;&nbsp;Finalizar compra &nbsp;
      <i class="fa fa-shopping-cart" aria-hidden="true"></i>
    </a>

    <div class="box-simular-entrega center-block text-center" *ngIf="carrinho?.quantidade > 0 && clienteLogado()">
      <a routerLink="/checkout/entrega">Simular entrega</a>
    </div>

    <div class="box-descontos" *ngIf="descontos > 0 && carrinho?.carrinho_id && carrinhoItens.length > 0">
      <span>Desconto:</span> {{ descontos | price }}
    </div>

    <ng-container *ngIf="!pedido">
      <div class="cart-itens">
        <ng-container *ngFor="let produto of carrinhoItens">
          <div class="product {{ produto.classe_oferta }}" (click)="cliqueCaptureAds(produto)">
            <div class="thumbnail">
              <div class="border-promotion">
                <div class="drill-price drill-price-xs text-success">
                  <div class="arrow-left">
                    <div class="bullet"></div>
                  </div>
                  <div class="info-price">
                    {{ produto.preco_total | price }}
                  </div>
                </div>

                <app-carrinho-spinner [callback]="1" [class]="1" [carrinhoId]="carrinho.carrinho_id" [itemId]="produto.item_id" [produtoId]="produto.mercadoria_id" [quantidade]="produto.quantidade"
                                      [tipoProduto]="produto.tipo" [quantidadeMaxima]="produto.quantidade_maxima"></app-carrinho-spinner>

                <div class="caption">
                  <p class="text-success description text-left">
                    <a *ngIf="produto.tipo !== 2" routerLink="/produtos/detalhe/{{
                        produto.mercadoria_id
                      }}/{{ produto.link }}">{{ produto.descricao | slice: 0:65 }}</a>
                    <a href="javascript:void(0);" *ngIf="produto.tipo === 2">{{
                      produto.descricao | slice: 0:65
                    }}</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="text-center mt20" *ngIf="paginacao?.total_items > paginacao?.items_per_page">
        <p>
          Para ter acesso à lista completa da sua compra,
          <a routerLink="/checkout/carrinho">clique aqui</a>.
        </p>
      </div>
    </ng-container>

    <div class="text-center text-warning mt20" *ngIf="pedido">
      <h4>Sua compra está em processo de finalização.</h4>
      <p style="margin: 15px">
        Para ter acesso à lista de sua compra,
        <a routerLink="/minha-conta/pedidos/detalhe/{{ pedido.id }}">clique aqui</a>.
      </p>
    </div>
  </ng-container>
</div>
